import {
  type AttachmentDto,
  useGetAttachmentId,
} from '#pie/internal/api/pie-bff';
import { downloadBlob } from '#pie/utils/downloadBlob';
import { FileAnchor } from '../file-anchor/FileAnchor';

export interface AttachmentAnchorProps {
  attachment: AttachmentDto;
}

export const AttachmentAnchor: React.FC<AttachmentAnchorProps> = ({
  attachment,
}) => {
  const { refetch, isFetching } = useGetAttachmentId(attachment.id, {
    query: {
      enabled: false,
      refetchOnWindowFocus: false,
    },
  });

  const handleClick = async () => {
    const { data } = await refetch();
    /* istanbul ignore else -- @preserve */
    if (data) {
      downloadBlob(data, attachment.fileName);
    }
  };

  return (
    <FileAnchor
      fileName={attachment.fileName}
      fileSize={attachment.bytes}
      onClick={handleClick}
      isLoading={isFetching}
    />
  );
};
